import { hideLoading, showLoading } from 'react-redux-loading-bar';
import api from '../../utils/api';

const ActionType = {
  RECEIVE_CATEGORIES: 'RECEIVE_CATEGORIES',
  CLEAR_CATEGORIES: 'CLEAR_CATEGORIES',
};

const receiveCategoriesActionCreator = (categories) => ({
  type: ActionType.RECEIVE_CATEGORIES,
  payload: {
    categories,
  },
});

const clearCategoriesActionCreator = () => ({
  type: ActionType.CLEAR_CATEGORIES,
});

const asyncReceiveCategories = () => async (dispatch) => {
  dispatch(showLoading());
  dispatch(clearCategoriesActionCreator());
  try {
    const categories = [];
    const threads = await api.getAllThreads();
    threads.map((thread) => {
      if (!categories.some((category) => category.category === thread.category)) {
        categories.push({ category: thread.category });
      }
      return categories;
    });
    dispatch(receiveCategoriesActionCreator(categories));
  } catch (error) {
    alert(error.message);
  }
  dispatch(hideLoading());
};

export {
  ActionType,
  clearCategoriesActionCreator,
  asyncReceiveCategories,
};
